import { render, staticRenderFns } from "./courseTmall.vue?vue&type=template&id=5ef875f2&scoped=true&"
import script from "./courseTmall.vue?vue&type=script&lang=js&"
export * from "./courseTmall.vue?vue&type=script&lang=js&"
import style0 from "./courseTmall.vue?vue&type=style&index=0&id=5ef875f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef875f2",
  null
  
)

export default component.exports